import type { Role } from '@/entities/user';

/**
 * Access rules for the refunds feature.
 * Refunds are ops-tracker only; no approval API — refunds start automatically on cancel/return.
 */

/** Roles that can view the refunds list and detail */
export const REFUNDS_VIEW_ROLES: readonly Role[] = ['admin'] as const;

/** Roles that can retry failed refunds */
export const REFUNDS_RETRY_ROLES: readonly Role[] = ['admin'] as const;

export function canViewRefunds(role: Role | null): boolean {
  if (!role) return false;
  return REFUNDS_VIEW_ROLES.includes(role);
}

export function canRetryRefund(role: Role | null): boolean {
  if (!role) return false;
  return REFUNDS_RETRY_ROLES.includes(role);
}
